import { ICard } from '../CardsWrapper/types';

export interface ICardForm {
  firstName: string;
  lastName: string;
  balance: number | '';
  payingOff: string;
}

export interface IAddCardProps {
  onSubmitCard: (card: ICard) => void;
  cardToEdit: ICard | null;
  onGoBack: () => void;
}

export enum CardPayingOffOptionsEnum {
  PAY_OFF = 'payOff',
  LEAVE_BALANCE = 'leaveBalance',
}
